import { gsap, Power3 } from "gsap";

export default class FormSwitcher {
    constructor() {

        this.switcher = document.querySelector(".js-form-switcher");
        this.radioBtns = document.querySelectorAll(".js-form-selector");

        if (this.switcher) {
            
            this.init();
            
        }

    }

    init() {
        this.radioBtns.forEach(element => {
            element.addEventListener("change", (e) => {
                let formID = e.target.dataset.form;

                if (formID) {
                    let formElement = document.querySelector(`[data-form-type="${formID}"]`);
                    document.querySelectorAll(`[data-form-type]`).forEach(element => { element.classList.add("hidden") });
                    formElement.classList.remove("hidden");
                }

            });
        });
    }

}